import { asyncActionType } from 'util/methods';

export const INSPECTION_FILTERS_APPLY = 'INSPECTION_FILTERS_APPLY';

//
// Fetch Job List
//

export const INSPECTION_LIST_FETCH_BEGIN = 'INSPECTION_LIST_FETCH_BEGIN';

export const INSPECTION_LIST_FETCH_SUCCESS = 'INSPECTION_LIST_FETCH_SUCCESS';

export const INSPECTION_LIST_FETCH_FAIL = 'INSPECTION_LIST_FETCH_FAIL';

//
// Inspection Job Search
//

export const INSPECTION_JOBS_FETCH_WITH_FILTERS_BEGIN = 'INSPECTION_JOBS_FETCH_WITH_FILTERS_BEGIN';

export const INSPECTION_JOBS_FETCH_WITH_FILTERS_SUCCESS =
  'INSPECTION_JOBS_FETCH_WITH_FILTERS_SUCCESS';

export const INSPECTION_JOBS_FETCH_WITH_FILTERS_FAIL = 'INSPECTION_JOBS_FETCH_WITH_FILTERS_FAIL';

export const INSPECTION_LIST_RESET = 'INSPECTION_LIST_RESET';

export const INSPECTION_FILTERS_RESET = 'INSPECTION_FILTERS_RESET';

//
// Fetch Analytics Chart DataURIs

export const INSPECTION_JOB_ANALYTICS_CHART_GET_BEGIN = 'INSPECTION_JOB_ANALYTICS_CHART_GET_BEGIN';

export const INSPECTION_JOB_ANALYTICS_CHART_GET_SUCCESS =
  'INSPECTION_JOB_ANALYTICS_CHART_GET_SUCCESS';

export const INSPECTION_JOB_ANALYTICS_CHART_GET_FAIL = 'INSPECTION_JOB_ANALYTICS_CHART_GET_FAIL';

export const INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_BEGIN =
  'INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_BEGIN';

export const INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_SUCCESS =
  'INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_SUCCESS';

export const INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_FAIL =
  'INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_FAIL';

export const InspectionTypes = {
  GET_INSPECTION_SERVICE_PROVIDER: asyncActionType('GET_INSPECTION_SERVICE_PROVIDER'),
  UPDATE_SEARCH_DATA: 'UPDATE_SEARCH_DATA',
};
